import React from 'react';
import {useAppDispatch} from "../redux";

import {useNavigate} from "react-router-dom";

// import './Filter.scss'

// @ts-ignore
import FilterComponent from "../components/filter";

export default function Filter() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    return (
        <div className="filter-wrapper">
            <FilterComponent/>
        </div>
    );
}
